<dt-modal-content [size]="'giant'" (closeClick)="dialogRef.close()" [contentPadding]="false" [flexContent]="true">
  <ng-template #title>
    <div class="center-icon">
      <mat-icon> category </mat-icon>
      <ng-container i18n>Ideen-Pool</ng-container>
    </div>
  </ng-template>
  <ng-template #subheader>
    <nav mat-tab-nav-bar class="header" [tabPanel]="tabPanel" mat-stretch-tabs="false" mat-align-tabs="start" disablePagination="true">
      @for (element of headerElements; track element; let i = $index) {
        <a
          class="header-element"
          mat-tab-link
          matRipple
          #tap="matRipple"
          [matRippleDisabled]="true"
          (click)="activeCategory = element.category; addNewElementField()"
          [active]="activeCategory === element.category"
          (dragenter)="dragEnter($event)"
          (dragover)="dragOverTap($event, element.category)"
          (dragleave)="dragLeaveTap($event)"
          (drop)="dropTap($event, element.category, tap)"
          [class.dragging]="isDragging && element.category !== activeCategory"
          [class.accept]="element.category === dragOverCategory && element.category !== activeCategory"
          [class.add-right-border]="
            isDragging &&
            (activeCategory === headerElements[i + 1]?.category ||
              (activeCategory !== 'influenceFactors' && element.category === 'influenceFactors'))
          "
        >
          <div class="header-element-wrapper">
            <span class="ellipsis">
              {{ isDragging && element.category !== activeCategory ? element.labelDragging : element.labelNotdragging }} ({{
                issues[element.category].length
              }})
            </span>
          </div>
        </a>
      }
    </nav>
  </ng-template>
  <ng-template #content>
    <mat-divider class="mat-divider-style"> </mat-divider>
    <div class="modal-content-structure">
      <div class="list">
        @for (element of issues[activeCategory]; track i; let i = $index) {
          <div
            class="aspect-box-frame"
            (dragenter)="dragEnter($event)"
            (dragover)="dragOverIssueRaisingBox($event, i)"
            (dragleave)="dragLeaveIssueRaisingBox($event)"
            (drop)="dropIssueRaisingBox()"
          >
            <dt-aspect-box
              [(name)]="issues[activeCategory][i]"
              [readonly]="isDragging"
              (nameChange)="onNameChange($event, i)"
              [draggable]="true"
              (dragstart)="dragStartIssueRaisingBox($event, i)"
              (dragend)="dragEndIssueRaisingBox()"
              [currentlyDraggingBox]="isDraggingBox(i)"
              [currentlyDragging]="isDragging"
              [showDeleteButton]="false"
            >
            </dt-aspect-box>
          </div>
        }
        @if (isAddingNew) {
          <div class="new-box-frame">
            <div class="wrapper-orange">
              <input
                class="input"
                #addingNew
                type="text"
                [(ngModel)]="newIssue"
                (keydown.enter)="addElement(true)"
                (keydown.escape)="addElement(false)"
                (blur)="addElement(false)"
                dtAutoFocus
              />
            </div>
          </div>
        }
        <div class="new-box-frame">
          <button class="add-button" (click)="addNewElementField()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      <div class="footer">
        @for (element of footerElements; track element) {
          @if (activeCategory === element.category) {
            <div
              id="dt-footer-element-{{ element.id }}"
              class="footer-element"
              [class.dragging]="isDragging"
              [class.accept]="overFooterElement === element.id"
              i18n
              matRipple
              #ripple="matRipple"
              [matRippleDisabled]="true"
              (dragenter)="dragEnter($event)"
              (dragover)="dragOverFooter($event, element.id)"
              (drop)="dropFooter($event, element.id, ripple, element.tooltip)"
              (dragleave)="dragLeaveFooter($event)"
              data-dismiss="modal"
            >
              <span class="text">{{ !isDragging ? element.labelNotdragging : element.labelDragging }}</span>
            </div>
          }
        }
        <div
          #deleteripple
          matRipple
          #ripple="matRipple"
          [matRippleDisabled]="true"
          [matRippleTrigger]="deleteripple"
          class="delete-element"
          (dragenter)="dragEnter($event)"
          (dragover)="dragOverFooter($event, 'delete')"
          (drop)="dropFooter($event, 'delete', ripple, null)"
          (dragleave)="dragLeaveFooter($event)"
          [class.accept]="overFooterElement === 'delete'"
          [class.dragging]="isDragging"
        >
          <div class="delete">
            <div class="center">
              <mat-icon>delete</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</dt-modal-content>

<div #tabPanel></div>
